<template>
  <el-container>
    <el-main>
      <el-form ref="form" label-width="80px">
        <div v-for="(item, index) in assistantList" :key="index">
          <el-divider content-position="left">助理 {{index+1}}</el-divider>
          <el-form-item label="助理姓名">
            <el-input @change="change($event, item, index)" v-model="item.name"></el-input>
          </el-form-item>
          <el-form-item label="助理电话">
            <el-input @change="change($event, item, index)" v-model="item.phone"></el-input>
          </el-form-item>
          <el-form-item label="助理职务">
            <el-input @change="change($event, item, index)" v-model="item.position"></el-input>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary" @click="addAssistant" icon="el-icon-plus">添加助理</el-button>
        </el-form-item>
      </el-form>
    </el-main>
  </el-container>
</template>

<script>
import $http from "../../../request.js";
import _ from "lodash";
export default {
  name: "assistant",
  created(){
    this.updateAssistantList(this.list);
  },
  props:{
    list:{
      type: Array,
      default:function(){
        return [];
      }
    }
  },
  watch:{
    list(list){
      this.updateAssistantList(list);
    }
  },
  data(){
    return {
      assistantList: [
        {
          name: "",
          phone: "",
          position: ""
        }
      ]
    };
  },
  methods:{
    updateAssistantList(list){
      this.assistantList = list;
      console.log(this.assistantList);
    },
    addAssistant(){
      this.assistantList = [
        ...this.assistantList,
        {
          name: "",
          phone: "",
          position: ""
        }
      ]
    },
    updateAssistant(params) {
      let url = "/api/member/member_assistant/add";
      if(params.id) {
        url = "/api/member/member_assistant/edit";
      }
      $http.post(url, params)
        .then(res=>{
          if (res.data.code===1){
            this.$message({
              message: params.id?"修改成功":"新增成功",
              type: 'success'
            });
            this.$emit('success');
          }
        });
    },
    change(e, item, index) {
      this.assistantList[index] = item;
      const params = {
        id: item.id||'',
        name: item.name,
        phone: item.phone,
        position: item.position
      }
      let toupdate = true;
      _.forIn(params, (val, key)=>{
        if (!val&&key!=='id') {
          toupdate = false;
        }
      });
      if (toupdate) {
        this.updateAssistant(params);
      }
    }
  }
};
</script>

<style lang="less">
  
</style>

